import { Box, Collapse, Divider, Stack, Typography } from "@mui/material";
import QueryPreservingLink from "../../components/QueryPreservingLink";
import React, { useState } from "react";
import { useTheme } from "@mui/material";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";

const MobileDropdown = ({ page, recentReportId, location }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const currentUrl = location?.pathname?.replace(/\/+$/, "");

  return (
    <Stack sx={{ alignItems: "center" }}>
      <Stack sx={{ p: 1 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            textDecoration: "none",
            color: page.submenu.some((item) => currentUrl?.includes(item.url))
              ? theme.palette.primary.main
              : theme.palette.secondary.main,
            cursor: "pointer",
            position: "relative",
          }}
          onClick={() => setOpen(!open)}
        >
          {page.name}

          <Box
            component="span"
            sx={{
              position: "absolute",
              top: "50%",
              right: "-25px",
              transform: "translateY(-50%)",
              height: 24,
              width: 24,
            }}
          >
            {open ? <ArrowDropUp /> : <ArrowDropDown />}
          </Box>
        </Typography>
      </Stack>

      <Collapse
        in={open}
        timeout="auto"
        sx={{ alignSelf: "stretch", backgroundColor: "grey.100" }}
      >
        {page.submenu.map((submenuItem, index) => {
          return (
            <Stack key={index}>
              <Stack sx={{ p: 1, alignItems: "center" }}>
                <Typography
                  component={QueryPreservingLink}
                  to={
                    submenuItem.name === "Pulse Report"
                      ? `${submenuItem.url}/${recentReportId}`
                      : submenuItem.url
                  }
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    textDecoration: "none",
                    color: theme.palette.secondary.main,
                    "&.active": {
                      color: theme.palette.primary.main,
                    },
                  }}
                  activeClassName="active"
                  className={
                    (submenuItem.name === "Pulse Report" ||
                      submenuItem.name === "Reports") &&
                    location?.pathname?.includes(submenuItem.url)
                      ? "active"
                      : ""
                  }
                >
                  {submenuItem.name}
                </Typography>
              </Stack>

              {index !== page.submenu.length - 1 && <Divider />}
            </Stack>
          );
        })}
      </Collapse>
    </Stack>
  );
};

export default MobileDropdown;
